import { AuthGuard } from '@/modules/auth/router/auth.guard';
import { OrganisationGuard } from '@/modules/auth/router/organisation.guard';
import multiguard from 'vue-router-multiguard';

export default [
    {
        name: 'retrieval',
        path: '/retrieval',
        component: () => import(/* webpackChunkName: "data-model" */ '@/modules/retrieval/views/RetrievalQueries.vue'),
        meta: { title: 'Retrieval', feature: ['retrieve.api', 'retrieve.files', 'retrieve.stream'] },
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
    {
        name: 'retrieval:create',
        path: '/retrieval/create',
        component: () => import(/* webpackChunkName: "retrieval" */ '@/modules/retrieval/views/RetrievalQuery.vue'),
        meta: {
            title: 'Create New Data Retrieval Query',
            feature: ['retrieve.api', 'retrieve.files', 'retrieve.stream'],
        },
        props: true,
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
    {
        name: 'retrieval:edit',
        path: '/retrieval/:id',
        component: () => import(/* webpackChunkName: "retrieval" */ '@/modules/retrieval/views/RetrievalQuery.vue'),
        props: true,
        meta: {
            title: 'View/Edit Data Retrieval Query',
            feature: ['retrieve.api', 'retrieve.files', 'retrieve.stream'],
        },
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
    {
        name: 'retrieval:configure',
        path: '/retrieval/:id/configure',
        component: () =>
            import(/* webpackChunkName: "retrieval" */ '@/modules/retrieval/views/ConfigureRetrievalQuery.vue'),
        props: true,
        meta: {
            title: 'Configure Data Retrieval Query',
            feature: ['retrieve.api', 'retrieve.files', 'retrieve.stream'],
        },
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
];
